export default "__VITE_ASSET__DNtuBhL5__"